<template>
	<input type="text" class="input" />
	<input type="text" class="input" />
</template>


